export enum BillingFrequency {
  CASH = 'Cash',
  FINANCED = 'Financed',
}
